




































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { TrainClassDto } from '@/api/models';
import classInfo from '@/components/common/classInfo.vue';
@Component({
  components: { classInfo }, //路由守卫
  beforeRouteEnter(to: any, from: any, next: any) {
    //全部日程页面回退
    if (from.name == 'schedule') {
      to.meta.isBack = true;
    }
    next();
  },
})
export default class SignUpIndex extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  solutionId: string = '';
  schedule = {
    icon: require('@/images/schedule.png'),
  };
  isDetail: boolean = true;
  title: string = '';
  classItem: Partial<TrainClassDto> = {
    id: '',
    className: '',
    deptName: '',
    address: '',
    trainType: '',
    days: 0,
    startDate: '',
    endDate: '',
    content: '',
    runClassType: '',
    objectScope: '',
    number: 0,
    //trainingSchedulings: [],
    //schedulingAttachmentKey: '',
  };
  //课程数
  courseCounts: number = 0;
  //总学时
  totalHours: number = 0;
  //钩子的触发顺序created-> mounted-> activated，退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated。
  activated() {
    window.addEventListener('pagehide', this.onPageUnload);
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      if (this.$route.params.classItem) {
        this.classItem = JSON.parse(this.$route.params.classItem);
        // this.courseCounts = this.classItem!.trainingSchedulings!.length;
        // this.classItem!.trainingSchedulings!.forEach(item => {
        //   this.totalHours += item.hours;
        // });
      } else {
        //从缓存中取数据
        let memoryClassItem = sessionStorage.getItem('signUpClassItem');
        this.classItem = JSON.parse(memoryClassItem!);
        // this.courseCounts = this.classItem!.trainingSchedulings!.length;
        // this.classItem!.trainingSchedulings!.forEach(item => {
        //   this.totalHours += item.hours;
        // });
      }
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  }
  //页面刷新
  onPageUnload() {
    sessionStorage.setItem('signUpClassItem', JSON.stringify(this.classItem));
  }
  //报到成功回调，不刷新页面更新报到状态
  signUpSuccess(classItem: any) {
    if (classItem.id == this.classItem.id) {
      this.$set(this.classItem, 'studentAuditStatu', 1);
    }
  }
}
